export default "__VITE_ASSET__BloOYbCP__"